import { Component, OnInit } from '@angular/core';
import { BroadcastService } from '../../core/services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Album } from '../../shared-api/albums/album.model';
import { AlbumManagerService } from '../../shared-api/albums/album-manager.service';

@Component({
    selector: 'myapp-folder',
    templateUrl: './folder.component.html',
    styleUrls: [ './folder.component.less' ]
})
export class FolderComponent implements OnInit
{
    loading = false;
    album: Album;

    constructor(private albumManager: AlbumManagerService,
                private broadcastService: BroadcastService,
                private route: ActivatedRoute,
                private router: Router)
    { }

    ngOnInit()
    {
        this.broadcastService.showHeader.next(true);
        this.route.params.subscribe(params =>
        {
            const albumId = params['id'] == null ? 0 : +params['id'];
            this.loadAlbum(albumId);
        });
    }

    private loadAlbum(id)
    {
        this.loading = true;
        this.albumManager.favorites().subscribe(() =>
        {
            this.albumManager.getAlbum(id, true).subscribe((parentAlbum: Album) =>
            {
                this.album = parentAlbum;
                this.loading = false;
            });
        });
    }

    onChildAlbumSelected(childAlbum: Album)
    {
        if (childAlbum.IsFolder)
        {
            this.router.navigate([ '/folder', childAlbum.Id ]);
            return;
        }

        this.router.navigate([ '/album', childAlbum.Id ]);
    }
}
